import CityPageTemplate from "../city-template/CityPageTemplate";
import { rexburgConfig } from "./data";

export default function RexburgPage() {
  return <CityPageTemplate config={rexburgConfig} />;
}